import { Component, forwardRef, Input } from "@angular/core";
import { NG_VALUE_ACCESSOR } from "@angular/forms";
import { ControlValueAccessorDirective } from "../../../Helpers/Directives/controlValueAccessor.directive";

@Component({
    selector: 'input-password',
    templateUrl: 'inputPassword.component.html',
    styleUrls: ['inputPassword.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => InputPasswordComponent),
            multi: true,
        }
    ],
})
export class InputPasswordComponent extends ControlValueAccessorDirective {

    private isPasswordVisible: boolean = false;
    
    @Input() placeholder:string = '';
    @Input() public readonly: boolean = false;

    constructor() {
        super();
    }

    // Get Password Type
    public get PasswordType() {
        return this.isPasswordVisible ? 'text' : 'password';
    }

    // Get Password Text
    public get PasswordIcon() {
        return this.isPasswordVisible ? 'visibility_off' : 'visibility';
    }

    // Show Password
    public showPassword() {
        this.isPasswordVisible = true;
    }

    // Hide Password
    public hidePassword() {
        this.isPasswordVisible = false;
    }

}